import queries from '@apis/queries';
import MyShopApi from '@apis/shop/MyShopApi';
import useUser from '@hooks/auth/useUser';
import useToast from '@hooks/ui/useToast';
import { ShopResponse } from '@models/shop';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useTranslation } from 'react-i18next';

function useToggleMyShop(shop?: ShopResponse) {
    const { t } = useTranslation('shopDetail');
    const toast = useToast();
    const { user } = useUser();
    const queryClient = useQueryClient();
    const { mutate } = useMutation({
        mutationFn: MyShopApi.toggleMyShop,
        onSuccess() {
            queryClient.invalidateQueries({ queryKey: queries.shop._def });
            toast.success(!shop?.isMyShop ? t('toast.myShopAdded') : t('toast.myShopRemoved'));
        },
        onError(e) {
            console.error(e);
            toast.error(t('toast.myShopFailed'));
        },
    });
    const toggleMyShop = () => {
        if (!user) {
            toast.error(t('toast.loginRequired'));
            return;
        }
        if (!shop) {
            toast.error(t('toast.noShopInfo'));
            return;
        }
        mutate(shop.id);
    };
    return {
        toggleMyShop,
    };
}

export default useToggleMyShop;
